<template>

    <div class="joueurItem">
           <div style="float:left" > 
           
           <s-button :label="(parseInt(equipeJoueur.numero)+1)" icon="" 
                :theme="getTheme"
                @onclick="editJoueur(equipeJoueur)"
                :afterIcon="changeFlagJoueur ? 'arrows-alt-h' : ''"
                v-if="equipeJoueur"
                />
                 
           </div>
            <div style="float:left" v-show="!equipeJoueur && changeFlagJoueur" > 
           <s-button  label="" icon=""  
                 :theme="getTheme"
                 @onclick="editJoueur(equipeJoueur, type, JX)"
                 
                 icon="question"
                 
                 
            />
            </div>
            <div :class="!changeFlagJoueur ? 'pseudo' : 'pseudoChange'"  v-if="equipeJoueur && !errorJoueur(equipeJoueur.J1)">
                {{getNameEquipe}}
            </div>
             <div class="joueurItem2">
                     {{getMeneur}}
            </div>
            <div class="joueurItem2"> {{getJ2}}</div>
            <div class="joueurItem2"> {{getJ3}}</div>
            <div class="showError" v-if="showError && errorJoueur(equipeJoueur)">
               <list-errors :errors="equipeJoueur.errorDetail[indexPartie]"
               @openModalJoueur="openModalJoueur"
               />
            </div> 
         
    </div>

</template>
<style scoped>
    .joueurItem {
        
        height: 100px;
        padding-top: 0px;
        font-size: 12px;
        width: 90%;
        max-width: 400px;
        color: white;
    }
      .joueurItem2 {
        margin-left: 50px;
        width: 60%;
        text-overflow: ellipsis;
        font-size: 12px;
        white-space: nowrap;
        overflow: hidden;
    }
     
    .pseudo {
        margin-left: 50px;
        width: 60%;
        text-overflow: ellipsis;
        font-size:18px;
        font-weight: bolder;
        white-space: nowrap;
        overflow: hidden;
    }
    .pseudoChange {
        margin-left: 65px;
        width: 60px;
        text-overflow: ellipsis;
        font-size: 12px;
        white-space: nowrap;
        overflow: hidden;
    }
</style>
<script>
import listErrors from "@/views/tournoi/inProgress/listErrors.vue"
export default {
    props: ["equipe", "JX", "type", "changeFlagJoueur", "showError", "indexPartie", "theme", "joueurs"],
     components: {
        listErrors
    },
    methods: {
        errorJoueur(joueur) {
            if (this.showError) {
                if (joueur) 
                        return joueur.errorDetail[this.indexPartie] != "undefined";
                    else
                        return false;
            }
            else
                return false
            
        },
        openModalJoueur() {
            this.$emit("openModalJoueur")
        },
        editJoueur(equipeJoueur, type, JX) {
        
            this.$emit("editJoueur", equipeJoueur, type, JX);
        }
    },
    computed: {
        equipeJoueur: {
            get()
            {
                
                return this.equipe[this.type].J1;
            }
        },
        getNameEquipe: {
            get() {
                var numero = this.equipeJoueur.numero;
              
                if (typeof(this.joueurs[numero].nameEquipe)=="undefined") {
                    return this.joueurs[numero].pseudo;
                }
                else if (this.joueurs[numero].nameEquipe=='')
                    return this.joueurs[numero].pseudo;
                else
                    return this.joueurs[numero].nameEquipe;
            }
        },
        getMeneur: {
            get() {
                if (this.equipeJoueur != null) {
                    var numero = this.equipeJoueur.numero;
                    return this.joueurs[numero].pseudo;
                }
                else
                    return "";
            },
        },
         getJ2: {
            get() {
                if (this.equipe[this.type].J2 != null) {
                    var numero = this.equipe[this.type].J2.numero
                    return this.joueurs[numero].pseudo;
                 }
                else
                    return "";
            }
        },
    
         getJ3: {
            get() {
                if (this.equipe[this.type].J3 != null) {
                    var numero = this.equipe[this.type].J3.numero
                    return this.joueurs[numero].pseudo;
                 }
                else
                    return "";
            }
        },
        getTheme: {
            get() {
                if (this.theme == null)
                    return this.type=='joueurs' ? 'is-small is-primary' : 'is-small is-danger'
                else
                    return this.theme + " is-small"
            }
        },
    }
}
</script>